/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {KeywordListResponse} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({providedIn: 'root'})
export class KeywordsService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * @summary Get Keywords
   */
  getKeywords<TData = KeywordListResponse>(options?: HttpClientBodyOptions): Observable<TData>;
  getKeywords<TData = KeywordListResponse>(options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  getKeywords<TData = KeywordListResponse>(options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getKeywords<TData = KeywordListResponse>(
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/keywords`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/keywords`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/keywords`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}
